module.exports = __webpack_public_path__ + "img/double_chevron_left.9ec6e6c9.svg";